/**
 * @generated SignedSource<<a99671a7325bc742b055cc7c1dfcdb15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useRecentAgentActivity_issue$data = {
  readonly id: string;
  readonly recentTriageEvents: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: "IssueFieldAddedEvent";
      readonly actor: {
        readonly __typename: string;
        readonly avatarUrl: string;
        readonly displayName?: string;
        readonly isAgent?: boolean;
        readonly isCopilot?: boolean;
        readonly login: string;
      } | null | undefined;
      readonly color: string | null | undefined;
      readonly createdAt: string;
      readonly issueField: {
        readonly name?: string;
      } | null | undefined;
      readonly value: string | null | undefined;
    } | {
      readonly __typename: "IssueFieldChangedEvent";
      readonly actor: {
        readonly __typename: string;
        readonly avatarUrl: string;
        readonly displayName?: string;
        readonly isAgent?: boolean;
        readonly isCopilot?: boolean;
        readonly login: string;
      } | null | undefined;
      readonly createdAt: string;
      readonly issueField: {
        readonly name?: string;
      } | null | undefined;
      readonly newColor: string | null | undefined;
      readonly newValue: string | null | undefined;
    } | {
      readonly __typename: "IssueFieldRemovedEvent";
      readonly actor: {
        readonly __typename: string;
        readonly avatarUrl: string;
        readonly displayName?: string;
        readonly isAgent?: boolean;
        readonly isCopilot?: boolean;
        readonly login: string;
      } | null | undefined;
      readonly createdAt: string;
      readonly issueField: {
        readonly name?: string;
      } | null | undefined;
    } | {
      readonly __typename: "IssueTypeAddedEvent";
      readonly actor: {
        readonly __typename: string;
        readonly avatarUrl: string;
        readonly displayName?: string;
        readonly isAgent?: boolean;
        readonly isCopilot?: boolean;
        readonly login: string;
      } | null | undefined;
      readonly createdAt: string;
      readonly issueType: {
        readonly name: string;
      } | null | undefined;
    } | {
      readonly __typename: "IssueTypeChangedEvent";
      readonly actor: {
        readonly __typename: string;
        readonly avatarUrl: string;
        readonly displayName?: string;
        readonly isAgent?: boolean;
        readonly isCopilot?: boolean;
        readonly login: string;
      } | null | undefined;
      readonly createdAt: string;
      readonly issueType: {
        readonly name: string;
      } | null | undefined;
    } | {
      readonly __typename: "IssueTypeRemovedEvent";
      readonly actor: {
        readonly __typename: string;
        readonly avatarUrl: string;
        readonly displayName?: string;
        readonly isAgent?: boolean;
        readonly isCopilot?: boolean;
        readonly login: string;
      } | null | undefined;
      readonly createdAt: string;
      readonly issueType: {
        readonly name: string;
      } | null | undefined;
    } | {
      readonly __typename: "LabeledEvent";
      readonly actor: {
        readonly __typename: string;
        readonly avatarUrl: string;
        readonly displayName?: string;
        readonly isAgent?: boolean;
        readonly isCopilot?: boolean;
        readonly login: string;
      } | null | undefined;
      readonly createdAt: string;
      readonly label: {
        readonly color: string;
        readonly name: string;
      };
    } | {
      readonly __typename: "UnlabeledEvent";
      readonly actor: {
        readonly __typename: string;
        readonly avatarUrl: string;
        readonly displayName?: string;
        readonly isAgent?: boolean;
        readonly isCopilot?: boolean;
        readonly login: string;
      } | null | undefined;
      readonly createdAt: string;
      readonly label: {
        readonly color: string;
        readonly name: string;
      };
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined> | null | undefined;
  };
  readonly viewerCanUpdateMetadata: boolean | null | undefined;
  readonly " $fragmentType": "useRecentAgentActivity_issue";
};
export type useRecentAgentActivity_issue$key = {
  readonly " $data"?: useRecentAgentActivity_issue$data;
  readonly " $fragmentSpreads": FragmentRefs<"useRecentAgentActivity_issue">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "actor",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "login",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "avatarUrl",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCopilot",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAgent",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        }
      ],
      "type": "Bot",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v5 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Label",
    "kind": "LinkedField",
    "name": "label",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "storageKey": null
  },
  (v4/*: any*/)
],
v6 = [
  (v2/*: any*/)
],
v7 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "IssueType",
    "kind": "LinkedField",
    "name": "issueType",
    "plural": false,
    "selections": (v6/*: any*/),
    "storageKey": null
  },
  (v4/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "issueField",
  "plural": false,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": (v6/*: any*/),
      "type": "IssueFieldCommon",
      "abstractKey": "__isIssueFieldCommon"
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "since"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useRecentAgentActivity_issue",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanUpdateMetadata",
      "storageKey": null
    },
    {
      "alias": "recentTriageEvents",
      "args": [
        {
          "kind": "Literal",
          "name": "itemTypes",
          "value": [
            "LABELED_EVENT",
            "UNLABELED_EVENT",
            "ISSUE_TYPE_ADDED_EVENT",
            "ISSUE_TYPE_CHANGED_EVENT",
            "ISSUE_TYPE_REMOVED_EVENT",
            "ISSUE_FIELD_CHANGED_EVENT",
            "ISSUE_FIELD_ADDED_EVENT",
            "ISSUE_FIELD_REMOVED_EVENT"
          ]
        },
        {
          "kind": "Literal",
          "name": "last",
          "value": 25
        },
        {
          "kind": "Variable",
          "name": "since",
          "variableName": "since"
        },
        {
          "kind": "Literal",
          "name": "visibleEventsOnly",
          "value": true
        }
      ],
      "concreteType": "IssueTimelineItemsConnection",
      "kind": "LinkedField",
      "name": "timelineItems",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": (v5/*: any*/),
              "type": "LabeledEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v5/*: any*/),
              "type": "UnlabeledEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v7/*: any*/),
              "type": "IssueTypeAddedEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v7/*: any*/),
              "type": "IssueTypeChangedEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v7/*: any*/),
              "type": "IssueTypeRemovedEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v1/*: any*/),
                (v8/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "newValue",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "newColor",
                  "storageKey": null
                },
                (v4/*: any*/)
              ],
              "type": "IssueFieldChangedEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v1/*: any*/),
                (v8/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                },
                (v3/*: any*/),
                (v4/*: any*/)
              ],
              "type": "IssueFieldAddedEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v1/*: any*/),
                (v8/*: any*/),
                (v4/*: any*/)
              ],
              "type": "IssueFieldRemovedEvent",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};
})();

(node as any).hash = "f24f24b7edf2338b5e6397e2d345e6f2";

export default node;
